import styled from "styled-components";

export const CabInfo = styled.ul`
  li {
    display: flex;
    align-items: center;
    margin-bottom: 1.2rem;
    font-size: 1.4rem;
    color: ${(p) => (p.theme ? p.theme.colors.dark : "#141823")};
    .newTag {
      height: 1.6rem;
      border-radius: 0.7rem;
      background-image: linear-gradient(112deg, #1149f3, #00c3ff);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 1rem;
      font-weight: 600;
      padding: 0 0.6rem;
      margin-left: 0.5rem;
    }
  }
`;

export const IconWrap = styled.span`
  width: 1.9rem;
  height: 1.9rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: solid 0.1rem #647a97;
  border-radius: 50%;
  margin-right: 1rem;
  border-width: ${(p) => (p.borderWidth ? p.borderWidth : "0.1rem")};
`;

